// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__1Ssxb","time":"styles_time__1iu_8"};